<template>
    <transition name="rightMove" appear>
        <div class="rightFlex">
            <!-- 会员首页右侧配置 -->
            <pageConfig v-show="selectPage == 1"></pageConfig>
            <!-- 积分任务右侧配置 -->
            <taskConfig v-show="selectPage == 2"></taskConfig>
            <!-- 积分乐园右侧配置 -->
            <playConfig v-show="selectPage == 3"></playConfig>
            <!-- 积分商城右侧配置 -->
            <shopConfig v-show="selectPage == 4"></shopConfig>
            <!-- 个人中心右侧配置 -->
            <personalConfig v-show="selectPage == 5"></personalConfig>
        </div>
    </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import pageConfig from './pageConfig/index'
import taskConfig from './taskConfig/index'
import playConfig from './playConfig/index'
import shopConfig from './shopConfig/index'
import personalConfig from './personalConfig/index'

export default {
    components: {
        pageConfig,
        taskConfig,
        playConfig,
        shopConfig,
        personalConfig
    },
    computed: {
        ...mapState(["selectPage"])
    },
}
</script>

<style lang="scss" scoped>
.rightFlex {
    width: 582px;
    height: 100%;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: all 1s;
}
.rightMove-enter {
    transform: translateX(100%);
}
.rightMove-enter-to {
    transform: translateX(0);
}
</style>